import type { SupSingleVaultSimplified, SupStoredAction } from "@/types";

import React, { Dispatch } from "react";

import { SupApe, SupVaultAdd } from "@repo/core-ui";
import { SupButton, SupToast, toast } from "@repo/core-ui";
import dictionaryConfig from "@/../config/dictionary.config";
import config from "@/../config/dapp.config";
import { getVaultApy } from "@/utils";

export function notifyDepositChange(
  singleVault: SupSingleVaultSimplified,
  storedDispatch: Dispatch<SupStoredAction>,
  customContent: string | undefined = undefined,
  showButton: boolean = true
) {
  toast.custom(
    // @ts-ignore
    t => (
      <SupToast
        color="success"
        icon={<SupVaultAdd />}
        title="Vault Added To Bag"
        content={
          customContent
            ? customContent
            : `Earning ${
                getVaultApy(singleVault) !== dictionaryConfig.statsDefaultValue
                  ? `${parseFloat(String(getVaultApy(singleVault))).toFixed(config.decimalsApyRoundingLimit)}%`
                  : "some"
              } APY with ${singleVault.friendly_name} vault on ${singleVault.protocol ? singleVault.protocol.name : ""} ${singleVault.chain.name} chain`
        }
        actions={
          showButton && (
            <SupButton
              prefixIcon={<SupApe />}
              variant="outlined"
              className="border border-current text-current"
              onClick={() => {
                storedDispatch({ type: "setOverlay", overlay: "deposit" });
                toast.remove(t.id);
              }}
            >
              Open Bag
            </SupButton>
          )
        }
        onClose={() => {
          toast.remove(t.id);
        }}
      />
    ),
    {
      id: `deposit-${singleVault.slug}`,
      duration: 4000,
    }
  );
}
